import { RootState } from 'src/state/RootState';
import { HISTORY } from 'src/constants/history';

export const DEFAULT_STATE: RootState = {
    sdk: {
        apiKey: 'need to provide',
        domain: 'need to provide',
        dnt: true,
    },
    router: {
        location: HISTORY.location,
        action: 'POP',
    },
    locale: HISTORY.location.pathname.startsWith('/de/')
        ? 'de'
        : 'en',
    query: '',
    search: {
        params: {
            query: '',
            section: null,
        },
        loading: false,
        data: null,
        error: null,
    },
    suggest: {
        suggests: [],
    },
};
